import { Link } from 'react-router-dom';
import SiteNavbar from '@/components/feature/SiteNavbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Technologies from './components/Technologies';
import EngagementModels from './components/EngagementModels';
import ClientSuccessScorecard from './components/ClientSuccessScorecard';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import GlobalPresence from './components/GlobalPresence';
import ReadingProgress from './components/ReadingProgress';
import LinkedInFeed from './components/LinkedInFeed';
import ScrollToTop from './components/ScrollToTop';
import FloatingCTA from './components/FloatingCTA';

function SectionCTA({ to, label }: { to: string; label: string }) {
  return (
    <div className="bg-stone-50/60 pb-8 md:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Link
          to={to}
          className="group relative inline-flex items-center gap-2.5 px-7 py-3.5 bg-navy-900 text-white text-sm font-semibold rounded-xl overflow-hidden transition-all duration-500 hover:shadow-xl hover:shadow-navy-900/25 hover:-translate-y-1"
        >
          <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out bg-gradient-to-r from-transparent via-white/15 to-transparent"></div>
          <span className="relative">{label}</span>
          <i className="ri-arrow-right-line relative transition-transform duration-300 group-hover:translate-x-1"></i>
        </Link>
      </div>
    </div>
  );
}

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <ReadingProgress />
      <SiteNavbar />
      <Hero />
      <About />
      <Services />
      <EngagementModels />
      <Technologies />
      {/* <SectionCTA to="/technologies" label="Explore All Technologies" /> */}
      {/* <SectionCTA to="/how-it-works" label="Learn How It Works" /> */}
      <WhyChooseUs />
      <ClientSuccessScorecard />
      <Testimonials />
      <LinkedInFeed />
      <GlobalPresence />
      <CTA />
      <Footer />
      <ScrollToTop />
      <FloatingCTA />
    </div>
  );
};

export default HomePage;